var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _circle, _circle2, _circle3, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrbanSafari01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:2.86;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:3.0477;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:1.1823;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:1.1823;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.1412;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,114.1c-1,0.7-1,3.2-1.1,6.9c-0.1,2.1,0.1,4.2,0.4,6.2c2.2,13.5,0.7,37.5,2.9,65.1c0.6,4.6-0.1,9.3-2,13.6 c-1.6,3.3-3.8,6.1-6.6,8.4c3.3,1.8,9.1,4.2,15.1,2.8c20.6-4.8,34.7-51.3,19-79.9C125.4,122.4,109,111.9,106,114.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.3,114.1c1,0.7,1,3.2,1.1,6.9c0.1,2.1-0.1,4.2-0.4,6.2c-2.2,13.5-0.7,37.5-2.9,65.1 c-0.6,4.6,0.1,9.3,2,13.6c1.6,3.3,3.8,6.1,6.6,8.4c-3.3,1.8-9.1,4.2-15.1,2.8c-20.6-4.8-34.7-51.3-19-79.9 C296.9,122.4,313.3,111.9,316.3,114.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.4,239.5c-0.4,66.6-0.1,116.6-0.4,183.2c0,1.9-0.1,20.3-0.1,26.7c-0.3,0-0.7,0-1,0 c-16.6,0.2-30.8-0.2-42.3-0.9c-25.2-1.4-37.5-3.7-48.8-7c-5-1.4-9-2.8-11.7-3.8c4.2-29,6.8-53.3,8.6-71.3c2-20.3,3-30.8,3.5-46 c0.9-22.6,0.2-45.3-2-67.8c-1.7-15.9-3.9-29.3-5.8-38.9c1-0.6,2-1.2,2.9-1.9l0,0c3.7-2.7,6.9-6.1,9.3-10.1c1.3-2.3,3.2-6.2,4.5-15.2 c0.4-3.1,1.2-10.2-0.1-27.5c-1-12.3-1.5-18.9-3.8-28c-1.5-5.8-3.4-11.5-5.8-17c-0.1-0.2-0.1-0.4-0.2-0.6l58.1-21.7l-6.2,22.9 l17.8,8.2l-14.5,12.6l37.4,66.6l1,1.3l0,0l7.8,10.3c-3.5,11.5-6.5,20.8-8,24.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.4,182.7c1.5,5.2,3.1,10.3,4.6,15.3l0,0v1.2c-1.5,5.1-3,10-4.4,14.6l-7.8-10.3l0,0l-1-1.3l-37.4-66.6 l14.5-12.6l-17.8-8.2l6.2-22.9l1.8-0.7c0.6,1.5,1.3,2.9,2.1,4.2c3.7,5.9,8.8,8.9,12.8,11.2c2.9,1.7,5.9,3,9.1,4.1 c0.3,0.1,0.6,0.2,0.9,0.3c0.4,0.1,0.7,0.2,1,0.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.9,437.1c-4.5,1.5-10.9,3.4-18.8,5.3c-18.4,4.5-32.4,5.7-49.3,7.1c-19.6,1.6-35.4,1.8-48,1.9h-13.9v-2 c0.3,0,0.7,0,1,0c0-6.4,0.1-24.8,0.1-26.7c0.3-66.6,0.1-116.6,0.4-183.2l1.3-1.7l10.4-13.7l2.1-2.8l4.2-5.5l45.2-75.3l-14.5-12.6 l17.8-8.2l-7.6-28.2l58.1,22.4c0,0.2-0.1,0.3-0.2,0.4c-4.5,13.2-7.6,26.8-9.3,40.6c-1.1,9-0.9,15.3-0.5,27.9 c0.1,2.2,0.5,13.2,5.1,20.9c0.9,1.5,2,3,3.2,4.4c1.8,2,4,3.7,6.3,5l0,0l0,0l0,0c0.8,0.4,1.6,0.8,2.5,1.2c-2,9.8-4.3,23.4-6,39.8 c-2.4,24-2.2,42.4-1.9,58.6c0.1,19,1.3,37.9,3.5,56.8c1.7,14.1,4.1,28.4,7.8,60.1C327.4,432.7,327.7,435.3,327.9,437.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.1,127.8l-15.5-13.5l2.6-5c4-1.4,7.9-3.3,11.7-6.5c4-3.4,7.2-7.5,9.6-12.2l1.9,0.7l7.6,28.2L248.1,127.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.6,140.5L215.9,217l-2.6,4.4l-2.1,2.8l-10.4,13.7l-1,3.6c0.2-0.3,4.2-16.1,7.8-27.6 c1.4-4.6,2.9-9.5,4.4-14.6c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.5,20.4-84.2,20.4-84.2l15.5,13.5L262.6,140.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "268.5,120 248.1,127.8 232.5,114.3 235.1,109.3 253.5,73.6 261.6,90.5  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.1,198.5c-0.1,0.2-0.1,0.4-0.2,0.6c-1.5,5.1-3,10-4.4,14.6l-7.8-10.3l0,0l-1-1.3l-37.4-66.6l14.5-12.6 l14.2-12.3l1.4-1.2c0,0,0.2,0.6,0.5,1.8c1.1,3.9,18.7,81.9,20.2,86.8l0,0C212,198.1,212.1,198.3,212.1,198.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "191.3,109.3 189.9,110.5 175.7,122.8 157.7,116.3 161.2,90.6 170.3,68.6  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 245.9,
    r: 4.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 293.5,
    r: 4.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 343.5,
    r: 4.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.8,228.7h-28.1c-5.5,0-10-4.5-10-10v-43.4h48.1v43.4C297.8,224.3,293.3,228.7,287.8,228.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 269.4,
    y1: 175.3,
    x2: 269.4,
    y2: 228.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 278.1,
    y1: 175.3,
    x2: 278.1,
    y2: 228.7
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "298.3,187.3 273.7,194.7 249.2,187.3 249.2,175 298.3,175  "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.7,
    cy: 187.2,
    r: 4.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.4,228.7h-28.1c-5.5,0-10-4.5-10-10v-43.4h48.1v43.4C175.3,224.3,170.9,228.7,165.4,228.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 146.9,
    y1: 175.3,
    x2: 146.9,
    y2: 228.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 155.7,
    y1: 175.3,
    x2: 155.7,
    y2: 228.7
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "175.8,187.3 151.3,194.7 126.8,187.3 126.8,175 175.8,175  "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.3,
    cy: 187.2,
    r: 4.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284.2,400.2h-36.7c-7,0-12.7-5.7-12.7-12.7v-54h62v54C296.9,394.5,291.2,400.2,284.2,400.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 260.2,
    y1: 333.5,
    x2: 260.2,
    y2: 400.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 271.6,
    y1: 333.5,
    x2: 271.6,
    y2: 400.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "297.5,349.6 265.9,359.6 234.3,349.6 234.3,333.1 297.5,333.1  "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.9,
    cy: 350.9,
    r: 4.6
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M174,400.7h-36.7c-7,0-12.7-5.7-12.7-12.7v-54h62v54C186.7,395,181,400.7,174,400.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 150,
    y1: 334,
    x2: 150,
    y2: 400.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 161.4,
    y1: 334,
    x2: 161.4,
    y2: 400.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "187.3,350 155.7,360 124.1,350 124.1,333.5 187.3,333.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.7,
    cy: 351.4,
    r: 4.6
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000103954106168198501090000013771817875556450445_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanSafari01);
export default __webpack_public_path__ + "static/media/Urban Safari-01.4e51369bdce32cdd1c0f265a55089eb8.svg";
export { ForwardRef as ReactComponent };